module.exports = __webpack_public_path__ + "assets/img/36_1448.bb1acb97.jpg";